import { render, staticRenderFns } from "./DownloadECG.vue?vue&type=template&id=a0e4e376&"
import script from "./DownloadECG.vue?vue&type=script&lang=js&"
export * from "./DownloadECG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports